import { EditPromo } from 'features/ManageCampaigns/EditPromoDialog/EditPromo'
import { useState } from 'react'
import { isPromotionCodeValid } from 'utils/promotionHelpers'

const MainPromo = ({
  promotionCode,
  setPromotionCode,
  minNightsToStay,
  setMinNightsToStay,
  maxDiscountPercentage,
  setMaxDiscountPercentage,
  setPromoTagline,
  promoTagline,
  hasPromoValidityDate,
  setHasPromoValidityDate,
  promoValidityStartDate,
  setPromoValidityStartDate,
  promoValidityEndDate,
  setPromoValidityEndDate
}) => {
  const [isUsingDiscount, setIsUsingDiscount] = useState(!!promotionCode)

  const isPromoValid = isUsingDiscount ? isPromotionCodeValid(promotionCode) : true

  return (
    <div>
      <EditPromo
        promoCode={promotionCode}
        setPromoCode={setPromotionCode}
        minNights={minNightsToStay}
        setMinNights={setMinNightsToStay}
        maxDiscount={maxDiscountPercentage}
        setMaxDiscount={setMaxDiscountPercentage}
        setPromoTagline={setPromoTagline}
        promoTagline={promoTagline}
        hasPromoValidityDateControls={true}
        hasPromoValidityDate={hasPromoValidityDate}
        setHasPromoValidityDate={setHasPromoValidityDate}
        promoValidityStartDate={promoValidityStartDate}
        setPromoValidityStartDate={setPromoValidityStartDate}
        promoValidityEndDate={promoValidityEndDate}
        setPromoValidityEndDate={setPromoValidityEndDate}
        isUsingDiscount={isUsingDiscount}
        setIsUsingDiscount={setIsUsingDiscount}
        isPromoValid={isPromoValid}
      />
    </div>
  )
}

export default MainPromo
